import * as e from "react";
const a = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13 7a2 2 0 10-4 0 2 2 0 004 0zm2 0a4 4 0 10-8 0 4 4 0 008 0zM12 14h-2a4 4 0 00-4 4h5.1c.15.739.463 1.419.9 2H6a2 2 0 01-2-2 6 6 0 016-6h2c.737 0 1.443.133 2.095.376-.837.345-1.56.91-2.095 1.624z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 13a4 4 0 110 8 4 4 0 010-8zm1.877 3.336a.508.508 0 00-.02-.686.497.497 0 00-.68-.03l-1.65 1.665-.65-.656a.497.497 0 00-.864.217.508.508 0 00.164.5l1 1.01a.497.497 0 00.7 0l2-2.02z",
      fill: "#2d6ded"
    }
  )
);
export {
  a as default
};
